<nav class="sidebar" [class.sidebar--collapsed]="collapsed()" role="navigation" aria-label="Menu principal">
  <a class="sidebar__logo" routerLink="/">
    @if (collapsed()) {
      <div class="sidebar__logo-collapsed">
        <app-icon src="icons/sidebar/logo_pricy.svg" alt="Logo" [width]="21" [height]="40" />
      </div>
    } @else {
      <app-icon src="img/common/logo_pricy.svg" alt="Logo" [width]="100" [height]="40" />
    }
  </a>

  <div class="sidebar__nav">
    @for (item of navItems(); track item.permission ?? item.path) {
      @if (item.sidebar; as sideItem) {
        <a
          [routerLink]="item.path"
          routerLinkActive="active"
          #rla="routerLinkActive"
          [attr.aria-label]="sideItem.label | transloco"
        >
          <app-nav-item
            [icon]="sideItem.icon"
            [label]="sideItem.label | transloco"
            [active]="rla.isActive"
            [collapsed]="collapsed()"
          />
        </a>
      }
    }
  </div>

  <div class="sidebar__footer">
    <app-icon-button
      class="collapse-icon"
      [class.collapse-icon--collapsed]="collapsed()"
      icon="icons/phosphor/regular/text-outdent.svg"
      [label]="'nav.collapse' | transloco"
      (click)="toggleCollapse()"
    />
    @if (user(); as currentUser) {
      <app-user-card
        [username]="currentUser.username"
        [email]="currentUser.email"
        [photo]="photo()"
        [collapsed]="collapsed()"
        (logoutClick)="logout()"
      />
    }
  </div>
</nav>
